import { Children, type ReactElement, isValidElement, useCallback, useState } from 'react'
import type { ToolProps } from './types.js'

import { Tool } from './Tool.js'

export function useTools(children: ReactElement<ToolProps>[] | ReactElement<ToolProps>) {
  const tools = Children.toArray(children).filter(isValidTool)
  const firstTool = tools[0] as ReactElement<ToolProps> | undefined

  const [activeTool, setValue] = useState<string>(() => firstTool?.props.id ?? '')

  const onChangeTool = useCallback((_: unknown, newValue: string) => {
    setValue(newValue)
  }, [])

  return {
    tools,
    activeTool,
    onChangeTool,
  }
}

function isValidTool(value: unknown): value is ReactElement<ToolProps> {
  if (!isValidElement(value)) return false
  return value.type === Tool
}
